<div id="page-container">
  <div id="content-wrap">
    <app-navigation-bar/>
    <router-outlet/>
  </div>
  <footer id="footer">
    <app-footer/>
  </footer>
</div>
<app-toast-list/>
